import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomOrder } from '@order/const';
import { Observable } from 'rxjs';
import { OrderDetailsComponentService } from '../order-details.component-service';

@Component({
  selector: 'sd-order-details-totals',
  templateUrl: './order-detail-totals.component.html',
  styleUrls: ['./order-detail-totals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderDetailTotalsComponent implements OnInit {
  order$: Observable<CustomOrder>;

  constructor(private orderDetailsComponentService: OrderDetailsComponentService) {}

  ngOnInit(): void {
    this.order$ = this.orderDetailsComponentService.getOrderDetails();
  }
}
